import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CashIcon, FilterIcon, HomeDeliveryIcon, MakeModelIcon } from "@cinch-nx/design-system-icons";
import styles from "./why-app.module.css";
var ComponentMap = {
    cash: /*#__PURE__*/ _jsx(CashIcon, {
        size: 24
    }),
    filter: /*#__PURE__*/ _jsx(FilterIcon, {
        size: 24
    }),
    "home-delivery": /*#__PURE__*/ _jsx(HomeDeliveryIcon, {
        size: 24
    }),
    "vehicle-front": /*#__PURE__*/ _jsx(MakeModelIcon, {
        size: 24
    })
};
export var WhyAppInformation = function(param) {
    var heading = param.heading, listOfItems = param.listOfItems, ariaLabelForList = param.ariaLabelForList, disclaimer = param.disclaimer;
    return /*#__PURE__*/ _jsxs("section", {
        className: styles.whyAppInformationContainer,
        children: [
            /*#__PURE__*/ _jsx("h1", {
                className: styles.whyAppInformationSectionHeading,
                children: heading
            }),
            /*#__PURE__*/ _jsx("ul", {
                "aria-label": ariaLabelForList,
                className: styles.whyAppInformationSectionList,
                children: listOfItems.map(function(item) {
                    var iconName = item.icon;
                    return /*#__PURE__*/ _jsxs("li", {
                        "aria-label": item.text,
                        className: styles.whyAppInformationListItem,
                        children: [
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.whyAppInformationIconCard,
                                children: ComponentMap[iconName]
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                className: styles.whyAppInformationIconCardText,
                                children: item.text
                            })
                        ]
                    }, item.text);
                })
            }),
            /*#__PURE__*/ _jsx("p", {
                className: styles.whyAppInformationDisclaimer,
                children: disclaimer
            })
        ]
    });
};
